module.exports = __webpack_public_path__ + "static/media/display-3.91ff483f.png";